import React from 'react'
import Bharatha from "../../Assests/natyafusion2026.jpg"
import { Link } from 'react-router-dom'
import Fusion from "../../Assests/summerdancecamp2026tile.jpg"
import Kids from "../../Assests/kidsdanceschool.jpg"

function classesComponent() {
  return (
    <div className='md:px-[192px] px-4 py-20 bg-white'>

      {/* Section Header */}
      <div className='text-center mb-14'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>What We Offer</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: 'Playfair Display, serif' }}>
          Our <span className='text-[#E40F94] italic'>Classes</span>
        </h1>
        <p className='mt-3 md:text-[18px] text-[16px] text-gray-500 leading-6'>Dance programs for all levels</p>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

{/* Class Cards */}
<div className='flex md:flex-row flex-col gap-8 justify-center'>

  <Link to='/danceClassPage'>
    <div className='group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer border-t-4 border-[#E40F94]'>
      <img src={Kids} className='w-[341px] h-[341px] object-cover transition-transform duration-500 group-hover:scale-110' alt="Kids Dance Classes" />
      <div className='absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300'></div>
      <div className='absolute bottom-0 left-0 right-0 p-5'>
        <p className='text-white font-bold text-[18px]'>Kids Dance Classes</p>
        <p className='text-white text-[14px] mt-1 leading-snug'>Fun and engaging lessons designed to introduce young learners to the world of dance</p>
        <p className='text-[#E40F94] text-[13px] uppercase tracking-widest mt-2'>Learn More →</p>
      </div>
    </div>
  </Link>

  <Link to='/summerCampPage'>
    <div className='group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer border-t-4 border-[#E40F94]'>
      <img src={Fusion} className='w-[341px] h-[341px] object-cover transition-transform duration-500 group-hover:scale-110' alt="Summer Dance Camp" />
      <div className='absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300'></div>
      <div className='absolute bottom-0 left-0 right-0 p-5'>
        <p className='text-white font-bold text-[18px]'>Summer Dance Camp</p>
        <p className='text-white text-[14px] mt-1 leading-snug'>Calling all Girls and Boys for a Fun & Enriching Cultural Experience!</p>
        <p className='text-[#E40F94] text-[13px] uppercase tracking-widest mt-2'>Learn More →</p>
      </div>
    </div>
  </Link>

  <Link to='/natyaFusionPage'>
    <div className='group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer border-t-4 border-[#E40F94]'>
      <img src={Bharatha} className='w-[341px] h-[341px] object-cover transition-transform duration-500 group-hover:scale-110' alt="NatyaFusion" />
      <div className='absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300'></div>
      <div className='absolute bottom-0 left-0 right-0 p-5'>
        <p className='text-white font-bold text-[18px]'>NatyaFusion</p>
        <p className='text-white text-[14px] mt-1 leading-snug'>Adult Women's Class </p>
        <p className='text-[#E40F94] text-[13px] uppercase tracking-widest mt-2'>Learn More →</p>
      </div>
    </div>
  </Link>

</div>

      {/* Schedule Info */}
      <div className='mt-16 bg-white rounded-2xl px-10 py-14 max-w-3xl mx-auto shadow-xl border border-gray-100'>
        <div className='text-center mb-10'>
          <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>Details</p>
          <h2 className='font-bold text-[32px] md:text-[38px] text-gray-900 leading-tight' style={{ fontFamily: 'Playfair Display, serif' }}>
            Schedule, Location & <span className='text-[#E40F94] italic'>Pricing</span>
          </h2>
          <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
        </div>
        <div className='space-y-6 text-[17px] text-gray-600'>
          <div className='flex items-start gap-4 p-5 bg-gray-50 rounded-xl'>
            <span className='text-2xl'>🗓️</span>
            <div>
              <p className='font-bold text-gray-900 text-[18px] mb-1'>Class Schedule</p>
              <p>Level 1 - 3 classes: Wednesdays 6–7pm.</p>
              <p>Elite Performance Group: Wednesdays 7–8pm.</p>
            </div>
          </div>
          <div className='flex items-start gap-4 p-5 bg-gray-50 rounded-xl'>
            <span className='text-2xl'>📍</span>
            <div>
              <p className='font-bold text-gray-900 text-[18px] mb-1'>Location</p>
              <p>2880 Broadway Bend Drive Building 2 Pearland, TX 77584</p>
            </div>
          </div>
          <div className='flex items-start gap-4 p-5 bg-gray-50 rounded-xl'>
            <span className='text-2xl'>💰</span>
            <div>
              <p className='font-bold text-gray-900 text-[18px] mb-1'>Pricing</p>
              <p>Class tuition fee rate is $100/month. Enrollment is continuous and billed monthly on the 1st of each month.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default classesComponent
